"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PureIconContainer = exports.ImpureIconContainer = void 0;
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
// function getAriaProps<T>(props: T): React.AriaAttributes {
//   const names = Object.keys(props);
//   const ariaProps = {} as T;
//   names.forEach((name: string) => {
//     // eslint-disable-next-line no-useless-escape
//     if (typeof name === 'string' && /^aria\-/.test(name) && typeof props[name] === 'string') {
//       ariaProps[name] = props[name];
//     }
//   });
//   return ariaProps;
// }
// function getDefaultContainerStyle(): React.HTMLAttributes<HTMLSpanElement>['style'] {
//   return {
//     display: 'inline-block',
//     fontSize: '16px',
//     color: 'inherit',
//     fontStyle: 'normal',
//     lineHeight: 0,
//     textAlign: 'center',
//     textTransform: 'none',
//     textRendering: 'optimizeLegibility',
//     WebkitFontSmoothing: 'antialiased',
//   };
// }
var COMMON_ICON_CLASSNAME = 'sun-ui-icon-common-style';
var SpanContainer = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var sx = props.sx,
    restProps = __rest(props, ["sx"]);
  return /*#__PURE__*/_react["default"].createElement(_Box2["default"], Object.assign({
    component: "span",
    sx: Object.assign({
      display: 'inline-block',
      fontStyle: 'normal',
      lineHeight: 0,
      textAlign: 'center',
      textTransform: 'none',
      textRendering: 'optimizeLegibility',
      WebkitFontSmoothing: 'antialiased'
    }, sx)
  }, restProps, {
    ref: ref
  }), props.children);
});
var PureIconContainer = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var size = props.size,
    color = props.color,
    bgColor = props.bgColor,
    children = props.children,
    className = props.className,
    style = props.style,
    iconName = props.iconName,
    restProps = __rest(props, ["size", "color", "bgColor", "children", "className", "style", "iconName"]);
  var targetStyle = {};
  if (typeof size === 'number' && size > 0) {
    targetStyle.fontSize = size;
  }
  if (typeof color === 'string' && color) {
    targetStyle.color = color;
  }
  if (typeof bgColor === 'string' && bgColor) {
    targetStyle.backgroundColor = bgColor;
  }
  targetStyle = Object.assign(Object.assign({}, targetStyle), style);
  // const ariaProps = getAriaProps<IPureIconContainerProps>(props);
  return /*#__PURE__*/_react["default"].createElement(SpanContainer, Object.assign({
    ref: ref,
    "data-icon-name": iconName,
    className: (0, _clsx["default"])(COMMON_ICON_CLASSNAME, className),
    style: targetStyle
  }, restProps), children);
});
exports.PureIconContainer = PureIconContainer;
var ImpureIconContainer = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var size = props.size,
    children = props.children,
    className = props.className,
    style = props.style,
    iconName = props.iconName,
    restProps = __rest(props, ["size", "children", "className", "style", "iconName"]);
  var targetStyle = {};
  if (typeof size === 'number' && size > 0) {
    targetStyle.fontSize = size;
  }
  targetStyle = Object.assign(Object.assign({}, targetStyle), style);
  // const ariaProps = getAriaProps<IPureIconContainerProps>(props);
  return /*#__PURE__*/_react["default"].createElement(SpanContainer, Object.assign({
    ref: ref,
    "data-icon-name": iconName,
    className: (0, _clsx["default"])(COMMON_ICON_CLASSNAME, className),
    style: targetStyle
  }, restProps), children);
});
exports.ImpureIconContainer = ImpureIconContainer;